import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './Result.css';

const Result = ({ score, totalQuestions, quizSet, onRestart, onShowRanking, onBackToHome }) => {
  const [playerName, setPlayerName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [savedMessage, setSavedMessage] = useState('');

  const percentage = Math.round((score / totalQuestions) * 100);

  const getScoreMessage = () => {
    if (percentage === 100) return '完璧です！宮崎県マスターですね！';
    if (percentage >= 80) return 'すばらしい！宮崎県についてとても詳しいですね！';
    if (percentage >= 60) return 'よくできました！宮崎県の知識が豊富ですね！';
    if (percentage >= 40) return 'まずまずです！もう少し頑張りましょう！';
    return 'もう一度チャレンジしてみましょう！';
  };

  const handleSaveScore = async () => {
    if (!playerName.trim()) {
      setSavedMessage('名前を入力してください');
      return;
    }

    setIsSaving(true);
    setSavedMessage('');

    try {
      await addDoc(collection(db, 'scores'), {
        name: playerName.trim(),
        score: score,
        totalQuestions: totalQuestions,
        percentage: percentage,
        setId: quizSet.id,
        setTitle: quizSet.title,
        category: quizSet.category,
        timestamp: new Date()
      });
      setSavedMessage('スコアを保存しました！');
      setTimeout(() => {
        onShowRanking(quizSet.id);
      }, 1500);
    } catch (error) {
      console.error('Error saving score:', error);
      setSavedMessage('保存に失敗しました。もう一度お試しください。');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="result-container">
      <h1 className="result-title">クイズ終了！</h1>

      <div className="score-circle">
        <div className="score-percentage">{percentage}%</div>
        <div className="score-fraction">
          {score} / {totalQuestions}
        </div>
      </div>

      <p className="score-message">{getScoreMessage()}</p>

      <div className="save-score-section">
        <h3>スコアをランキングに登録</h3>
        <input
          type="text"
          className="name-input"
          placeholder="お名前を入力"
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          maxLength={20}
          disabled={isSaving}
        />
        <button
          className="save-button"
          onClick={handleSaveScore}
          disabled={isSaving || !playerName.trim()}
        >
          {isSaving ? '保存中...' : 'スコアを保存'}
        </button>
        {savedMessage && (
          <p className={`save-message ${savedMessage.includes('失敗') ? 'error' : 'success'}`}>
            {savedMessage}
          </p>
        )}
      </div>

      <div className="result-buttons">
        <button className="restart-button" onClick={onRestart}>
          もう一度挑戦
        </button>
        <button className="ranking-button" onClick={onShowRanking}>
          ランキングを見る
        </button>
        <button className="home-button" onClick={onBackToHome}>
          ホームに戻る
        </button>
      </div>
    </div>
  );
};

export default Result;
